import React from 'react';
import { StyleSheet, View, ViewStyle } from 'react-native';

import { spacing } from '../constants/theme';

type RowContainerProps = {
  style?: ViewStyle;
};

export const RowContainer: React.FC<RowContainerProps> = ({
  children,
  style,
}) => {
  return (
    <View style={[styles.row, styles.lBottomSpacing, style]}>{children}</View>
  );
};

const styles = StyleSheet.create({
  row: { flexDirection: 'row', justifyContent: 'space-between' },
  lBottomSpacing: {
    marginBottom: spacing.l,
  },
});
